import { create } from "zustand";
import { cleanupModalBodyStyles } from "utils/modalUtils";

const useModalStore = create((set, get) => ({
  modalState: "closed",
  modalType: "",
  modalData: {},
  setModalState: state => {
    set({ modalState: state });
  },
  setModalType: type => {
    set({ modalType: type });
  },
  setModalData: data => {
    // Cleanup modal body styles when modal is being closed
    // Handle different close state values: "CLOSE", "closed", "close"
    const closeStates = ["CLOSE", "closed", "close"];
    if(data?.state && closeStates.includes(data.state)) {
      cleanupModalBodyStyles();
    }
    set({ modalData: data });
  },
  configureModal: ({ modalState, modalType }) => {
    set({
      modalState,
      modalType
    });
  },
  resetStore: () => {
    set({
      modalState: "closed",
      modalType: "",
      modalData: {}
    });
  }
}));

export default useModalStore;
